import gql from "graphql-tag";
import { PaymentGatewayFragment } from "../fragments/payment-gateway.fragment";

export const UPDATE_ONE_PAYMENT_GATEWAY = gql`
  mutation ($input: UpdateOnePaymentGatewayInput!) {
    updateOnePaymentGateway(input: $input) {
      ...PaymentGateway
    }
  }
  ${PaymentGatewayFragment}
`;
